module.exports = __webpack_public_path__ + "img/clippy.c6b23471.svg";